export default "__VITE_ASSET__zqVZGcf1__"